export default __webpack_public_path__ + "static/springandsummer (4)-84daff858bc20bc27f41dd051c7097a2.jpeg";